import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import * as firebase from 'firebase'

import './UserProfileDetails.css'

class UserProfileDetails extends FirebaseComponent {
  constructor() {
    super()
    this.state.profile = {}

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        firebase.database().ref(`profiles/${user.uid}`)
          .on('value', snapshot => {
            this.setState({ profile: snapshot.val() })
          })
      }
    })
  }

  render() {
    return (
      <div>
        <div className="user-profile-details">
          <a><img src={this.state.profile.profileImage} className="profile-image" alt="profile"/></a>
          <p>{this.state.profile.firstName} {this.state.profile.lastName}</p>
          <p>{this.state.profile.email}</p>
        </div>
      </div>
    )
  }
}

export default UserProfileDetails



// WEBPACK FOOTER //
// ./src/UserProfileDetails.js